import { useEffect, useState } from 'react';

const WA = 'https://wa.me/5555996946460?text=Olá,%20vim%20pelo%20Google%20e%20quero%20agendar%20consulta';

const links = [
  { label: 'Início', id: 'home' },
  { label: 'Sobre', id: 'sobre' },
  { label: 'Serviços', id: 'servicos' },
  { label: 'Diferenciais', id: 'diferenciais' },
  { label: 'Contato', id: 'contato' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
      <div className="max-w-8xl mx-auto px-6 sm:px-8 lg:px-10">
        <div className="flex justify-between items-center h-25">
          <div className="flex-shrink-0">
            <img
              src="/img/logo1.png"
              alt="Dra. Mariangela Escobar"
              className="h-24 w-auto"
            />
          </div>
          <div className="hidden md:flex items-center space-x-8">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollTo(l.id)}
                className="text-sm font-medium text-[#3A3A3A] hover:text-[#6B705C] transition-colors whitespace-nowrap cursor-pointer"
              >
                {l.label}
              </button>
            ))}
            <a
              href={WA}
              onClick={(e) => {
                e.preventDefault();

                if (typeof gtag_report_conversion === 'function') {
                  gtag_report_conversion(WA);
                } else {
                  window.open(WA, '_blank');
                }
              }}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-[#4F5D4A] to-[#6B705C] text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:from-[#3D4A38] hover:to-[#4F5D4A] transition-all duration-300 whitespace-nowrap cursor-pointer shadow-md shadow-[#6B705C]/15"
            >
              Agendar
            </a>
          </div>
          <button
            className="md:hidden p-2 rounded-md text-[#3A3A3A] hover:bg-[#F5F5F0] cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#DDE0D7] px-4 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-medium text-[#3A3A3A] hover:text-[#6B705C] text-left cursor-pointer whitespace-nowrap"
            >
              {l.label}
            </button>
          ))}
          <a
            href={WA}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-[#4F5D4A] to-[#6B705C] text-white px-6 py-3 rounded-lg text-sm font-semibold text-center whitespace-nowrap"
          >
            Agendar
          </a>
        </div>
      )}
    </nav>
  );
}